<div *ngIf="powerEnable; else elseBlockCredit">
  <div class="card">
    <div class="card-header">
        <h3 class="card-title text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"/>
          </svg>
            Poderes
           <button class="btn btn-sm" (click)="openAddPower()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-plus" viewBox="0 0 16 16">
              <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5"/>
              <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
            </svg>
           </button>
           
           <button class="btn btn-sm" (click)="openAddPdlPerson()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wallet" viewBox="0 0 16 16">
              <path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a2 2 0 0 1-1-.268M1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1"/>
            </svg>
           </button>

          </h3> 
          <div *ngIf="message" class="alert alert-secondary" role="alert">{{ message }}</div>
        
    </div>
    <div class="card-body">
        <h3>Matriz de Poderes</h3>

        <div>
            <table mat-table [dataSource]="powerResponse" class="mat-elevation-z8 demo-table">
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element">{{element.position}}</td>
              </ng-container>
          
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Nombre del apoderado</th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="notary">
                <th mat-header-cell *matHeaderCellDef>Notario</th>
                <td mat-cell *matCellDef="let element">{{element.notary.name}}</td>
              </ng-container>
          
              <!-- Weight Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Tipo de poder</th>
                <td mat-cell *matCellDef="let element">{{element.type.name}}</td>
              </ng-container>
          
              <!-- Symbol Column -->
              <ng-container matColumnDef="extension">
                <th mat-header-cell *matHeaderCellDef>Tipo de facultades</th>
                <td mat-cell *matCellDef="let element">{{element.extension.name}}</td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="attributes">
                <th mat-header-cell *matHeaderCellDef>Atributos</th>
                <td mat-cell *matCellDef="let element">
                  <ul>
                    <li *ngFor="let attribute of element.attributes">
                      {{ attribute.name }} <!-- assuming 'name' is a property of each attribute -->
                    </li>
                  </ul>
                </td>
              </ng-container>

              <ng-container matColumnDef="tenancy_pdf">
                <th mat-header-cell *matHeaderCellDef class="text-center">ID apoderado</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <button type="button" class="btn btn-sm"
                    [ngClass]="hasTenancyPowerDocument(element) ? 'btn-outline-primary' : 'btn-outline-secondary'"
                    [disabled]="!hasTenancyPowerDocument(element)"
                    (click)="openPowerDocumentModal(element, 'tenancy', $event)"
                    [attr.title]="hasTenancyPowerDocument(element) ? 'Ver documento de identificación del apoderado' : 'Sin documento adjunto'">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" class="bi bi-file-earmark-text">
                      <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
                      <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v1A1.5 1.5 0 0 1 11 3.5H14.5L9.5 1z"/>
                    </svg> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-vcard" viewBox="0 0 16 16">
                      <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"/>
                      <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z"/>
                    </svg>
                    <!-- Ver -->
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="original_pdf">
                <th mat-header-cell *matHeaderCellDef class="text-center">Poder original</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <button type="button" class="btn btn-sm"
                    [ngClass]="hasOriginalPowerDocument(element) ? 'btn-outline-primary' : 'btn-outline-secondary'"
                    [disabled]="!hasOriginalPowerDocument(element)"
                    (click)="openPowerDocumentModal(element, 'original', $event)"
                    [attr.title]="hasOriginalPowerDocument(element) ? 'Ver documento del poder original' : 'Sin documento adjunto'">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" class="bi bi-file-earmark-pdf">
                      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 11 3.5H14.5L11 1z"/>
                    </svg> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-briefcase" viewBox="0 0 16 16">
                      <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5"/>
                    </svg>
                    <!-- Ver -->
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="registered_pdf">
                <th mat-header-cell *matHeaderCellDef class="text-center">Poder registrado</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <button type="button" class="btn btn-sm"
                    [ngClass]="hasRegisteredPowerDocument(element) ? 'btn-outline-primary' : 'btn-outline-secondary'"
                    [disabled]="!hasRegisteredPowerDocument(element)"
                    (click)="openPowerDocumentModal(element, 'registered', $event)"
                    [attr.title]="hasRegisteredPowerDocument(element) ? 'Ver documento del poder registrado' : 'Sin documento adjunto'">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" class="bi bi-file-earmark-check">
                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 11 3.5H14.5L11 1z"/>
                    </svg> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-seam" viewBox="0 0 16 16">
                      <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"/>
                    </svg>
                    <!-- Ver -->
                  </button>
                </td>
              </ng-container>
              
              <!-- Symbol Column -->
              <!-- <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">

                  {{element.status}}
                </td>
              </ng-container>                 -->

              <!-- Symbol Column -->
              <ng-container matColumnDef="end_at">
                <th mat-header-cell *matHeaderCellDef>Fecha de Vencimiento</th>
                <td mat-cell *matCellDef="let element">{{element.end_at}}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">
                  {{ getStatus(element) }}
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="deletePower(element, $event)" title="Eliminar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                      <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                    </svg>
                  </button>
                </td>
              </ng-container>

              
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                (click)="clickedRows.add(row)"
                [class.demo-row-is-clicked]="clickedRows.has(row)"
                *matRowDef="let row; columns: displayedColumns;"
              ></tr>
            </table>
          
            <div>
              <h4>Detalles del Poder</h4>
            </div>
          
            <!-- Conditionally render the message if no rows are clicked -->
            <div *ngIf="!clickedRows.size">Haz Click para ver el detalle del poder.
            </div>
            <div>
              <!-- Clear Button -->
              <button class="btn mt-3" *ngIf="clickedRows.size > 0"  (click)="clearClickedRows()">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                </svg> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
              </button>
            </div>
            <!-- Display clicked rows using *ngFor -->
            <ul>
              <li *ngFor="let clickedRow of clickedRows">
                <div class="">
                  <p>
                    Poder Notarial otorgado a <u>{{clickedRow.tenancy.name}}</u> 
                    con RFC: <u>{{clickedRow.tenancy.taxid}}</u> y código postal: <u>{{clickedRow.tenancy.zip}}</u>, 
                    sobre la propiedad con escritura pública <u>{{clickedRow.commercial_folio}}</u> inscrita en el Registro Público el día <u>{{clickedRow.commercial_folio_date}}.</u>
                    Este poder es expedido por el notario número <u>{{clickedRow.notary.num}}</u>, <u>{{clickedRow.notary.name}}</u>,y corresponde a un poder de tipo <u>{{clickedRow.type.name}}</u> con extension <u>{{clickedRow.extension.name}}.</u> 
                    <br>
                    Atributos del poder:
                    <br>
                    <u *ngFor="let attribute of clickedRow.attributes">
                      {{ attribute.name }} , <!-- assuming 'name' is a property of each attribute -->
                    </u>
                    <br>  
                    valido a partir del día <u>{{clickedRow.start_at}}</u>  y hasta el día <u>{{clickedRow.end_at}}</u> 
                    contemplando los siguientes límites <u>{{clickedRow.limits}}</u> con los siguientes comentarios <u>{{clickedRow.comments}}</u>.
                    ERNESTO197086$$.
                  </p>

                </div>
              </li>

            </ul>

          </div>
          

    </div>

  </div>
</div>
<ng-template #elseBlockCredit>
  <p class="text-danger">No cuentas con funcionalidad para cargar poderes</p>
</ng-template>

<!-- Power document preview (same UX as beneficiary identity document) -->
<ng-template #powerDocumentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ currentPowerDocTitle || 'Documento' }}</h5>
    <div class="d-flex align-items-center gap-2">
      <a *ngIf="documentPreviewUrl" [href]="documentPreviewUrl" [download]="getPowerDownloadFileName()" class="btn btn-sm btn-outline-primary" title="Descargar">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="me-1"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
        Descargar
      </a>
      <button type="button" class="btn-close" aria-label="Cerrar" (click)="closePowerDocumentModal()"></button>
    </div>
  </div>
  <div class="modal-body border-bottom bg-light py-2" *ngIf="currentPowerDocFileName">
    <div class="small"><strong>Archivo:</strong> {{ currentPowerDocFileName }}</div>
  </div>
  <div class="modal-body">
    <div *ngIf="documentLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Cargando documento...</p>
    </div>
    <div *ngIf="!documentLoading && documentErrorMessage" class="alert alert-warning mb-0">
      {{ documentErrorMessage }}
    </div>
    <div *ngIf="!documentLoading && documentPreviewUrl && !documentErrorMessage" class="document-preview-container">
      <div *ngIf="isPdfContent()" class="document-preview-pdf">
        <span class="badge bg-secondary mb-2">PDF</span>
        <pdf-viewer [src]="documentPreviewUrl" [render-text]="true" style="width: 100%; height: 70vh;"></pdf-viewer>
      </div>
      <div *ngIf="isImageContent()" class="document-preview-image text-center">
        <span class="badge bg-secondary mb-2">{{ getImageTypeLabel() }}</span>
        <div class="overflow-auto" style="max-height: 70vh;">
          <img [src]="documentPreviewUrl" alt="Documento" class="img-fluid">
        </div>
      </div>
      <div *ngIf="!isPdfContent() && !isImageContent()" class="alert alert-info">
        Tipo de archivo no soportado para vista previa. Formatos válidos: PDF, JPEG, PNG.
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closePowerDocumentModal()">Cerrar</button>
  </div>
</ng-template>

